import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Partnership from './pages/Partnership';
import Gallery from './pages/Gallery'; // Import Gallery Page
import Articles from './pages/Articles'; // Import Articles Page
import ArticleDetail from './pages/ArticleDetail'; // Import Article Detail Page
import Karir from './pages/Karir'; // Import Karir Page
import KarirDetail from './pages/KarirDetail'; // Import Karir Detail Page
import Contact from './pages/Contact'; // Import Contact Page
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import MediaLibrary from './pages/admin/MediaLibrary';
import GalleryManager from './pages/admin/GalleryManager';
import TeamManager from './pages/admin/TeamManager';
import StaticContentManager from './pages/admin/StaticContentManager';
import ArticlesManager from './pages/admin/ArticlesManager';
import ArticleEditor from './pages/admin/ArticleEditor';
import LokerManager from './pages/admin/LokerManager';
import ApplicantsManager from './pages/admin/ApplicantsManager';
import Settings from './pages/admin/Settings';
import { NotificationProvider } from './context/NotificationContext';
import { AuthProvider } from './context/AuthContext'; // Import AuthProvider
import ProtectedRoute from './components/ProtectedRoute'; // Import ProtectedRoute

// ScrollToTop Component to handle navigation safely
const ScrollToTop = () => {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]); // Only trigger on path change

  return null;
};

function App() {
  return (
    <NotificationProvider>
      <Router>
        <ScrollToTop />
        <AuthProvider> {/* AuthProvider now wraps all routes */}
          <div className="flex flex-col min-h-screen">
            <Routes>
              {/* Admin Login Route (accessible without auth) */}
              <Route path="/xcbdsll/admn/lgn" element={<Login />} />

              {/* Protected Admin Routes */}
              <Route element={<ProtectedRoute />}>
                <Route path="/admin/dashboard" element={<Dashboard />} />
                <Route path="/admin/media-library" element={<MediaLibrary />} />
                <Route path="/admin/gallery" element={<GalleryManager />} />
                <Route path="/admin/team" element={<TeamManager />} />
                <Route path="/admin/static-content" element={<StaticContentManager />} />
                <Route path="/admin/articles" element={<ArticlesManager />} />
                <Route path="/admin/articles/new" element={<ArticleEditor />} />
                <Route path="/admin/articles/edit/:id" element={<ArticleEditor />} />
                <Route path="/admin/loker" element={<LokerManager />} />
                <Route path="/admin/applicants" element={<ApplicantsManager />} />
                <Route path="/admin/settings" element={<Settings />} />
              </Route>
              
              {/* Public Routes */}          
              <Route path="*" element={
                <>
                  <Navbar />
                  <main className="flex-grow">
                    <Routes>
                              <Route path="/" element={<Home />} />
                              <Route path="/about" element={<About />} />
                              <Route path="/partnership" element={<Partnership />} />
                              <Route path="/gallery" element={<Gallery />} />                      <Route path="/articles" element={<Articles />} />
                      <Route path="/articles/:slug" element={<ArticleDetail />} />
                      <Route path="/karir" element={<Karir />} />
                      <Route path="/karir/:id" element={<KarirDetail />} />
                      <Route path="/contact" element={<Contact />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              } />
            </Routes>
          </div>
        </AuthProvider>
      </Router>
    </NotificationProvider>
  );
}

export default App;
